import theme from '../theme/theme';

const {
  Icons: { sortBy },
} = theme;

export const SortByList = [
  {
    name: 'price',
    icon: sortBy.Price,
    sortby: 'low-high',
  },

  {
    name: 'time',
    icon: sortBy.Clock,
    sortby: 'low-high',
  },

  {
    name: 'rating',
    icon: sortBy.StarGray,
    sortby: 'high-low',
  },

  {
    name: 'current-location',
    icon: sortBy.GPS,
    sortby: 'near-you',
  },
];
